import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Loja from './pages/Loja';
import Produto from './pages/Produto';
import Fechamento from './pages/Fechamento';
import CassemsLanding from './pages/CassemsLanding';
import CassemsShell from './pages/CassemsShell';
import CassemsCheckout from './pages/CassemsCheckout';
import CassemsAdmin from './pages/CassemsAdmin';
import CintaLanding from './pages/CintaLanding';
import Salas from './pages/Salas';
import CircuitoLanding from './pages/CircuitoLanding';
import Tutoriais from './pages/Tutoriais';
import { trackPublicPageView } from './lib/publicAnalytics';

export default function App() {
  const location = useLocation();

  useEffect(() => {
    trackPublicPageView(`${location.pathname}${location.search}`);
    if (location.hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [location.pathname, location.search, location.hash]);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/loja" element={<Loja />} />
      <Route path="/loja/:id" element={<Produto />} />
      <Route path="/cassems" element={<CassemsShell />}>
        <Route index element={<CassemsLanding />} />
        <Route path="checkout" element={<CassemsCheckout />} />
      </Route>
      <Route path="/cassems-admin" element={<CassemsAdmin />} />
      <Route path="/cinta" element={<CintaLanding />} />
      <Route path="/fechamento" element={<Fechamento />} />
      <Route path="/salas" element={<Salas />} />
      <Route path="/circuito" element={<CircuitoLanding />} />
      <Route path="/tutoriais" element={<Tutoriais />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
